function moveElementsProductblock() {
  if (!document.body.classList.contains('template-product')) return;

  if (window.matchMedia("(max-width: 788px)").matches) {
    var instaMob = document.querySelector('#shopify-block-AdXN3bkRObmIxbjFuN__instafeed_app_block_MxjTiW');
    var imageBlockMob = document.querySelector('#shopify-section-template--24672860963146__custom_liquid_FjfKA6');
    if (instaMob && imageBlockMob && !imageBlockMob.contains(instaMob)) {
      imageBlockMob.appendChild(instaMob);
    }

    var reviewsMob = document.querySelector('#shopify-section-template--24672860963146__custom_liquid_FjfKA6');
    var productDescMob = document.querySelector('.productdescription');
    if (reviewsMob && productDescMob && !productDescMob.contains(reviewsMob)) {
      productDescMob.appendChild(reviewsMob);
    }

   var reviewsArchiveMobiel = document.querySelector('#shopify-section-template--24672860864842__custom_liquid_nfbckQ');
   var galleryArchiveMobiel = document.querySelector('.productdescription');
    if (reviewsArchiveMobiel && galleryArchiveMobiel && !galleryArchiveMobiel.contains(reviewsArchiveMobiel)) {
      galleryArchiveMobiel.appendChild(reviewsArchiveMobiel);
    }
  }

  if (window.matchMedia("(min-width: 789px)").matches) {
    var instaProductblock = document.querySelector('#shopify-block-AdXN3bkRObmIxbjFuN__instafeed_app_block_MxjTiW');
    var imageProductblok = document.querySelector('#shopify-section-template--24672860963146__custom_liquid_FjfKA6');
    if (instaProductblock && imageProductblok && !imageProductblok.contains(instaProductblock)) {
      imageProductblok.appendChild(instaProductblock);
    }

    var reviewsProductblock = document.querySelector('#shopify-section-template--24672860963146__custom_liquid_FjfKA6');
    var galleryProductblock = document.querySelector('.gallery');
    if (reviewsProductblock && galleryProductblock && !galleryProductblock.contains(reviewsProductblock)) {
      galleryProductblock.appendChild(reviewsProductblock);
    }

   var reviewsArchive = document.querySelector('#shopify-section-template--24672860864842__custom_liquid_nfbckQ');
   var galleryArchive = document.querySelector('.gallery');
    if (reviewsArchive && galleryArchive && !galleryArchive.contains(reviewsArchive)) {
      galleryArchive.appendChild(reviewsArchive);
    }
  }

  var reviewBlockOptieTwee = document.querySelector('.reviewblokproduct');
  var mainImageOptieTwee = document.querySelector('.main-image');
  if (reviewBlockOptieTwee && mainImageOptieTwee && !mainImageOptieTwee.contains(reviewBlockOptieTwee)) {
    mainImageOptieTwee.appendChild(reviewBlockOptieTwee);
  }

  var accordionProductblock = document.querySelector('.not-in-quickbuy.product-detail-accordion');
  var productDescProductblock = document.querySelector('.productdescription');
  if (accordionProductblock && productDescProductblock && !productDescProductblock.contains(accordionProductblock)) {
    productDescProductblock.appendChild(accordionProductblock);
  }
}

document.addEventListener('DOMContentLoaded', moveElementsProductblock);

setTimeout(moveElementsProductblock, 1000);
setTimeout(moveElementsProductblock, 3000);


var intervalproductForm = setInterval(function() {
    var productForm = document.querySelector('.product-form');
    if (!productForm) return;

    var labelsproductForm = productForm.querySelectorAll('.label');
    if (!labelsproductForm.length) return;

    var changedproductForm = false;

    for (var i = 0; i < labelsproductForm.length; i++) {
      var text = labelsproductForm[i].textContent.trim();

      if (text === 'Color') {
        labelsproductForm[i].textContent = 'Choose your color';
        changedproductForm = true;
      } else if (text === 'Kleur') {
        labelsproductForm[i].textContent = 'Kies je kleur';
        changedproductForm = true;
      } else if (text === 'Size') {
        labelsproductForm[i].textContent = 'Choose your size';
        changedproductForm = true;
      } else if (text === 'Maat') {
        labelsproductForm[i].textContent = 'Kies je maat';
        changedproductForm = true;
      }
    }

    // Stop zodra alles is aangepast
    if (changedproductForm) {
      clearInterval(intervalproductForm);
    }
  }, 300);
